import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../Loader";
import AppContext from "../../AppContext";
import { groupBy } from "@progress/kendo-data-query";
import { formatDate } from "@telerik/kendo-intl";
import "./../../index.css";
import axios from "axios";
import { BASE_URL, formatAlarmValue } from "../../constant";
import KendoLoadingPanel from "../KendoLoadingPanel";
import BtnLoader from "../BtnLoader";
import { Trans, useTranslation } from "react-i18next";
import { ReactSVG } from "react-svg";

const filterButtonsData = [
  { status: "critical", icon: "critical-icon.svg", label: "Critical" },
  { status: "warning", icon: "warning-icon.svg", label: "Warning" },
  { status: "info", icon: "info-icon.svg", label: "Info" },
];

const AlarmCard = ({
  index,
  a,
  parameter,
  alarm,
  disabledButtonAlarms,
  acknowledgeAlarm,
  alarmCount,
  onStatusCollapseClick,
  getTimeZoneDateTime,
  restAlarmsUpdateCount,
  t,
  darkMode,
}) => {
  return (
    <div
      style={{
        // borderRightColor: parameter?.color,
        backgroundColor: parameter?.cardBgColor
          ? parameter?.cardBgColor
          : darkMode
          ? "rgb(24 ,24 ,27 )"
          : "rgb(212 ,212 ,216 )",
      }}
      className={`flex justify-between transition-all ease-in-out duration-300 bg-zinc-300  ${
        alarmCount !== null
          ? alarm.status === "warning"
            ? "dark:border-amber-500 border-[#454655]"
            : alarm.status === "critical"
            ? "dark:border-red-600 border-red-400"
            : "dark:border-yellow-400 border-yellow-300"
          : "border-zinc-500"
      }  sm:mb-2 mb-1 sm:pt-2 pt-1 sm:mx-2 mx-1 rounded-lg border-2`}
      key={a.id}
    >
      <div
        className={`dark:text-gray-500 text-gray-600 w-full md:text-xs sm:text-xxs text-xxxs font-semibold`}
      >
        <div className="flex flex-col  sm:px-4 px-2 py-2 ">
          <div className="flex items-center sm:gap-2 gap-1 justify-between w-full sm:h-11 h-8">
            <div className="flex sm:gap-2 gap-1">
              <div
                className={`dark:bg-black dark:text-white bg-black text-white sm:h-6 sm:w-6 h-4 w-4 rounded-full md:text-xs sm:text-xxs text-xxxs flex items-center justify-center`}
              >
                {index + 1}
              </div>
              <div
                className={`dark:text-white text-black w-fit flex flex-col items-start gap-1 md:text-sm sm:text-xs text-xxs font-medium`}
              >
                &nbsp;
                {alarm?.alarmName}
                <span
                  className={`dark:text-neutral-500 text-neutral-700 md:text-xs sm:text-xxs text-xxxs`}
                >
                  &nbsp;{parameter?.name}
                </span>
              </div>
              <div
                className={`dark:bg-zinc-800 bg-zinc-400 text-white h-fit sm:px-2 px-1 sm:py-1 rounded md:text-xs sm:text-xxs text-xxxs font-semibold flex justify-center items-center`}
              >
                {formatAlarmValue(
                  alarm.alarmType,
                  alarm.sensorValue,
                  "flex-row",
                  parameter?.type
                )}
                &nbsp;
                {parameter?.unit}
              </div>
            </div>
            <div className="md:w-7 sm:w-5 w-3 h-full flex flex-col items-center">
              <div
                className={`${
                  alarm.status === "warning"
                    ? "dark:border-amber-500 border-amber-300"
                    : alarm.status === "critical"
                    ? "dark:border-red-600 border-red-400"
                    : "dark:border-yellow-400 border-yellow-500"
                } rounded-full md:w-7 sm:w-5 w-3 md:h-7 sm:h-5 h-3 sm:p-0 p-[3px] flex justify-center items-center border`}
              >
                <img
                  src={
                    alarm.status === "warning"
                      ? "warning-icon.svg"
                      : alarm.status === "critical"
                      ? "critical-icon.svg"
                      : "info-icon.svg"
                  }
                  alt="Severity Icon"
                />
              </div>
            </div>
          </div>
          <div className="flex flex-col font-semibold mt-2 md:text-xs sm:text-xxs text-xxxs py-1 sm:pb-3 pb-1">
            <div className="dark:text-white text-black">
              <span className="text-neutral-500">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                {t("home.alarmList.alarmCard.reportedTime")}
                &nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;
              </span>
              {formatDate(
                getTimeZoneDateTime(alarm.timeStamp),
                "dd-MMM-yyyy hh:mm a"
              )}
            </div>
          </div>
        </div>
        {alarm.acknowledgeUser && (
          <div
            className={`dark:bg-black bg-white left-0 mb-0  md:text-xs sm:text-xxs text-xxxs font-medium flex sm:p-4 p-2 w-full md:gap-32 sm:gap-24 gap-16`}
          >
            <div className="w-full flex sm:gap-3 gap-1">
              <div className="flex items-center">
                <img
                  src="Acknowledge-icon.svg"
                  alt="AcknowledgeIcon"
                  style={{ filter: "invert(40%)", height: 20 }}
                />
              </div>
              <div className="flex justify-between">
                <div className="flex flex-col gap-1">
                  <label
                    className={`dark:text-white text-black md:text-xs sm:text-xxs text-xxxs font-semibold`}
                  >
                    {formatDate(
                      getTimeZoneDateTime(alarm.acknowledgeTime),
                      "dd-MMM-yyy hh:mm:s a"
                    )}
                  </label>
                  <label className="text-neutral-500 font-medium md:text-xxs sm:text-xxxs text-[6px]">
                    {t("home.alarmList.alarmCard.acknowledgedTime")}
                  </label>
                </div>
              </div>
              <div className="flex md:text-4xl sm:text-3xl text-2xl items-center justify-center font-light -mt-3">
                |
              </div>
              <div className="flex md:gap-8 sm:gap-6 gap-4">
                <div className="flex flex-col gap-1">
                  <label
                    className={`dark:text-white text-black md:text-xs sm:text-xxs text-xxxs font-semibold`}
                  >
                    {alarm.acknowledgeUser}
                  </label>
                  <label className="text-neutral-500 font-medium md:text-xxs sm:text-xxxs text-[6px]">
                    {t("home.alarmList.alarmCard.acknowledgedUser")}
                  </label>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="">
          <hr className="border-neutral-600 font-bold md:text-lg sm:text-base text-sm" />
        </div>
        <div className="w-full flex justify-between gap-1 sm:px-3 px-2 md:text-xs sm:text-xxs text-[6px] sm:my-3 my-2 ">
          <div>
            {alarmCount !== null && alarmCount !== 0 && (
              <button
                type="button"
                className={`dark:text-white text-black border-neutral-500 border-2 sm:gap-2 gap-1 sm:h-8 h-6 rounded-4xl text-center md:w-28 sm:w-24 w-16 flex items-center justify-center disabled:opacity-25`}
                onClick={() =>
                  onStatusCollapseClick(a.value, alarm.assetId, alarm.status)
                }
              >
                {alarmCount}&nbsp;{t("home.alarmList.alarmCard.more")}
                {a?.collapsed ? (
                  <ReactSVG
                    src="drop-arrow-icon.svg"
                    className="rotate-180 sm:h-auto h-1 flex items-center justify-center"
                    beforeInjection={(svg) => {
                      svg.setAttribute(
                        "style",
                        `stroke: ${darkMode ? "white" : "black"}`
                      );
                    }}
                  />
                ) : (
                  <ReactSVG
                    src="drop-arrow-icon.svg"
                    className="sm:h-auto h-1 flex items-center justify-center"
                    beforeInjection={(svg) => {
                      svg.setAttribute(
                        "style",
                        `stroke: ${darkMode ? "white" : "black"}`
                      );
                    }}
                  />
                )}
              </button>
            )}
          </div>
          <button
            type="button"
            className={`border-2 sm:h-8 h-6 rounded-4xl text-center ${
              alarm.acknowledgeUser
                ? `md:w-32 sm:w-28 w-20 border-neutral-500 dark:text-white text-black`
                : "md:w-40 sm:w-36 w-28 border-lime-600 text-lime-600"
            } justify-center flex gap-1 items-center px-2 disabled:cursor-not-allowed`}
            disabled={disabledButtonAlarms.length > 0}
            onClick={() =>
              acknowledgeAlarm(alarm, alarmCount ? "multiple" : "single")
            }
          >
            {alarm.acknowledgeUser ? (
              !disabledButtonAlarms.some((p) => p.alarmId === alarm.id) ? (
                alarmCount ? (
                  t("home.alarmList.alarmCard.closeAll")
                ) : (
                  t("home.alarmList.alarmCard.close")
                )
              ) : (
                <div className="flex gap-1 items-center">
                  <BtnLoader />
                  <span>
                    &nbsp;
                    {alarmCount
                      ? restAlarmsUpdateCount > 0
                        ? restAlarmsUpdateCount
                        : ""
                      : ""}
                  </span>
                  <span>&nbsp;{t("home.alarmList.alarmCard.closing")}</span>
                </div>
              )
            ) : (
              <div className="px-1 flex gap-1">
                {!disabledButtonAlarms.some((p) => p.alarmId === alarm.id) ? (
                  <img
                    src="Acknowledge-icon.svg"
                    alt="AcknowledgeIcon"
                    className="sm:h-auto h-2"
                  />
                ) : (
                  <BtnLoader />
                )}
                <span>
                  {!disabledButtonAlarms.some((p) => p.alarmId === alarm.id) ? (
                    alarmCount ? (
                      t("home.alarmList.alarmCard.acknowledgeAll")
                    ) : (
                      t("home.alarmList.alarmCard.acknowledge")
                    )
                  ) : (
                    <span>
                      &nbsp;
                      {alarmCount
                        ? restAlarmsUpdateCount > 0
                          ? restAlarmsUpdateCount
                          : ""
                        : ""}
                      &nbsp;
                      {t("home.alarmList.alarmCard.acknowledging")}
                    </span>
                  )}
                </span>
              </div>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

const AlarmList = ({ setOpen, open }) => {
  const navigate = useNavigate();
  const {
    alarm,
    assets,
    authCtx,
    setAssets,
    updatedAlarm,
    apiLoaded,
    config,
    getTimeZoneDateTime,
    darkMode,
  } = useContext(AppContext);
  const { t } = useTranslation();
  const [alarms, setAlarms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [alarmLoaded, setAlarmLoaded] = useState(false);
  const [groupedAlarms, setGroupedAlarms] = useState([]);
  const [disabledButtonAlarms, setDisabledButtonAlarms] = useState([]);
  const [filterOptions, setFilterOptions] = useState({
    filtered: false,
    previousKey: null,
    currentKey: "",
  });

  const handleFilterClick = (filterKey) => {
    if (
      filterOptions.filtered &&
      filterOptions.previousKey !== null &&
      filterOptions.previousKey === filterKey
    ) {
      groupAlarms(alarms, false);
      setFilterOptions({ filtered: false, previousKey: null, currentKey: "" });
    } else {
      const filteredData = alarms.filter((a) => a.status === filterKey);
      groupAlarms(filteredData, false);
      setFilterOptions({
        filtered: true,
        previousKey: filterKey,
        currentKey: filterKey,
      });
    }
  };

  const acknowledgeAlarm = async (alarm, actionType) => {
    const btnType = !alarm.acknowledgeUser ? "acknowledge" : "clear";

    let payload;
    if (actionType === "multiple") {
      const alarmAsset = groupedAlarms.find((ga) => ga.value === alarm.assetId);
      const statusAlarms = alarmAsset.items.find(
        (as) => as.value === alarm.status
      ).items;
      const paramAlarms = statusAlarms.find(
        (x) => x.value === alarm.parameterId
      ).items;
      const filterCondition = !alarm.acknowledgeUser
        ? (i) => !i.acknowledgeUser
        : (i) => i.acknowledgeUser !== null;

      payload = createPayload(paramAlarms.filter(filterCondition), btnType);
    } else if (actionType === "single") {
      const alrm = alarms.find((a) => a.id === alarm.id);
      payload = createPayload(
        [{ id: alrm.id, timeStamp: alrm.timeStamp }],
        btnType
      );
    }

    setDisabledButtonAlarms(
      payload.alarms.map((ak) => ({
        alarmId: ak.id,
      }))
    );

    try {
      const res = await axios.post(
        `${BASE_URL}/AssetAlarm/UpdateAlarmAction`,
        payload
      );
      if (res.status === 200) setDisabledButtonAlarms([]);
    } catch (error) {
      setDisabledButtonAlarms([]);
    }
  };

  const createPayload = (alarms, type) => ({
    buttonType: type,
    user: authCtx.profile.name,
    time: new Date(),
    alarms: alarms
      .map((sa) => ({ id: sa.id, key: sa.timeStamp }))
      .sort((a, b) => new Date(a.key) - new Date(b.key)),
  });

  useEffect(() => {
    if (updatedAlarm && updatedAlarm.alarms) {
      const updateFields = {
        clear: {
          clearedTime: updatedAlarm.time,
          clearedUser: updatedAlarm.user,
        },
        acknowledge: {
          acknowledgeTime: updatedAlarm.time,
          acknowledgeUser: updatedAlarm.user,
        },
      };
      setAlarms((pre) => {
        const updatedAlarms = pre.map((i) => {
          const alrm = updatedAlarm.alarms.find((a) => a.id === i.id);
          return alrm ? { ...i, ...updateFields[updatedAlarm.ButtonType] } : i;
        });
        return updatedAlarms;
      });
    }
  }, [updatedAlarm]);

  const getAlarmHistory = async () => {
    setLoading(true);
    setAlarms([]);
    setGroupedAlarms([]);
    if (assets && assets.length > 0 && alarms.length === 0 && !loading) {
      setAlarmLoaded(true);
      const assetIds = assets.map((x) => {
        return x.id;
      });
      let res = await axios.post(
        `${BASE_URL}/AssetAlarm/MonitoringGetAllAlarm`,
        assetIds
      );
      setAlarms(res.data);
    }
    setLoading(false);
    // groupAlarms(res.data);
  };

  useEffect(() => {
    if (!alarmLoaded) getAlarmHistory();
  }, [assets]);

  const customSort = (a, b) => {
    if (a.value === "critical" && b.value === "warning") return -1;
    else if (a.value === "warning" && b.value === "critical") return 1;
    return 0;
  };

  const groupAlarms = (data, changeAssetStatus) => {
    const groupedData = groupBy(data, [{ field: "assetId" }]).map((gd) => ({
      ...gd,
      items: groupBy(gd.items, [
        { field: "status" },
        { field: "parameterId" },
      ]).sort(customSort),
    }));
    if (changeAssetStatus)
      setAssets(
        (pre) =>
          pre &&
          pre.map((pa) => {
            const assetGroup = groupedData.find((x) => x.value === pa.id);
            const criticalAlarm = assetGroup?.items.find(
              (i) => i.value === "critical"
            );
            const latestStatus =
              criticalAlarm ||
              assetGroup?.items.find((i) => i.value === "warning");

            return {
              ...pa,
              latestAlarm: latestStatus ? latestStatus.items[0].items[0] : null,
            };
          })
      );

    setGroupedAlarms((pre) =>
      groupedData.map((gd) => ({
        ...gd,
        collapsed: false,
        items: gd.items.map((i) => ({
          ...i,
          items: i.items.map((ii) => {
            const statusAlarm = pre
              .find((p) => p.value === gd.value)
              ?.items.find((gi) => gi.value === i.value)
              ?.items.find((x) => x.value === ii.value);
            return {
              ...ii,
              collapsed:
                statusAlarm && statusAlarm.collapsed
                  ? statusAlarm.collapsed
                  : false,
            };
          }),
        })),
      }))
    );
  };

  const onStatusCollapseClick = (value, assetId, status) => {
    setGroupedAlarms((pre) =>
      pre.map((p) =>
        p.value === assetId
          ? {
              ...p,
              items: p.items.map((i) =>
                i.value === status
                  ? {
                      ...i,
                      items: i.items.map((ii) =>
                        ii.value === value
                          ? { ...ii, collapsed: !ii.collapsed }
                          : ii
                      ),
                    }
                  : i
              ),
            }
          : p
      )
    );
  };

  const onCollapseClick = (value) => {
    setGroupedAlarms((pre) =>
      pre.map((p) =>
        p.value === value ? { ...p, collapsed: !p.collapsed } : p
      )
    );
  };

  useEffect(() => {
    if (updatedAlarm && updatedAlarm.Alarms) {
      const updateFields = {
        clear: {
          clearedTime: updatedAlarm.Time,
          clearedUser: updatedAlarm.User,
        },
        acknowledge: {
          acknowledgeTime: updatedAlarm.Time,
          acknowledgeUser: updatedAlarm.User,
        },
      };
      // let filteredAlarms = [];
      setAlarms((pre) => {
        const updatedAlarms = pre.map((i) => {
          const alrm = updatedAlarm.Alarms.find((a) => a.Id === i.id);
          return alrm ? { ...i, ...updateFields[updatedAlarm.ButtonType] } : i;
        });
        const filteredAlarms = updatedAlarms.filter((ua) => !ua.clearedUser);
        // groupAlarms(filteredAlarms, setAssets);
        return filteredAlarms;
      });
      setDisabledButtonAlarms((pre) =>
        pre.filter((x) => !updatedAlarm.Alarms.some((y) => y.Id === x.alarmId))
      );
    }
  }, [updatedAlarm]);

  useEffect(() => {
    if (alarms.length > 0) {
      groupAlarms(alarms, true);
    }
  }, [alarms]);

  useEffect(() => {
    if (alarm.length > 0) {
      let data = [];
      setAlarms((pre) => {
        let formatedAlarm = alarm.flat();
        if (alarms != null && alarm.length > 0)
          data = [...formatedAlarm, ...pre];
        else if (alarm.length > 0) data = formatedAlarm;
        return data;
      });
    }
  }, [alarm]);

  return (
    <div className="flex flex-col w-full h-full overflow-y-auto rounded-t-lg duration-500 ease-in-out">
      <div
        className={`flex md:px-6 sm:px-4 px-2 sm:py-2 py-1 items-center rounded-t-md justify-between dark:bg-gradient-to-r dark:from-red-800 dark:to-orange-600 bg-gradient-to-b from-red-500 to-orange-300`}
      >
        <div className="flex items-center gap-2 ">
          <label
            className={`font-semibold md:text-sm sm:text-xs text-xxs dark:text-gray-300 text-gray-50`}
          >
            {t("home.alarmList.headerText")}
          </label>
          <div
            className={`dark:bg-red-600 bg-red-700 flex rounded-full md:h-8 sm:h-6 h-5 md:min-w-[32px] min-w-[24px] px-1 justify-center items-center`}
          >
            <div
              className={`dark:bg-red-500 bg-red-600 md:min-w-[24px] min-w-[18px] sm:px-2 px-1 md:h-6 sm:h-4 h-3 rounded-full text-white font-semibold md:text-xs sm:text-xxs text-xxxs flex justify-center items-center `}
            >
              {alarms ? alarms.length : "0"}
            </div>
          </div>
        </div>
        <div className="md:h-5 sm:h-4 h-3 rounded-lg flex items-center sm:gap-4 gap-2">
          <button
            type="button"
            className="border border-white flex items-center sm:pr-3 pr-2 sm:gap-3 gap-1 p-1 rounded-md"
            onClick={() => navigate(`/alarmList`)}
          >
            <img
              src="AllAlarms.svg"
              className="md:h-5 sm:h-4 h-3"
              alt="alarmlist"
            />
            <label className="md:text-xs sm:text-xxs text-xxxs text-white">
              {t("home.alarmList.allAlarmsBtnTxt")}
            </label>
          </button>
          <button
            type="button"
            className="lg:flex hidden"
            onClick={() => setOpen(!open)}
          >
            <img
              src="Union.svg"
              alt="union"
              className="rotate-180 text-orange-300 sm:h-auto h-1"
            />
          </button>
        </div>
      </div>
      <div
        className={`dark:bg-zinc-950 bg-zinc-300 relative flex flex-col h-full overflow-y-auto sm:pl-2 pl-1`}
      >
        <div className={`dark:bg-zinc-950 bg-zinc-300 flex sticky top-0 z-20`}>
          <div
            className={`dark:bg-zinc-800 dark:text-gray-300 dark:border-zinc-500 bg-[#454655] text-white border-zinc-600 flex justify-between w-full mr-1 items-center md:text-xs sm:text-xxs text-xxxs  font-normal gap-3 md:px-8 sm:px-6 px-4 md:pr-9 sm:pr-6 pr-4 sticky z-10 py-2 top-2 bottom-2 mt-2 mb-2 border rounded-lg`}
          >
            {filterButtonsData.map((fbm, index) => (
              <button
                type="button"
                className={`flex items-center ${
                  filterButtonsData.length === index + 1 ? "" : "border-r"
                }  border-neutral-600 sm:pr-3 pr-2`}
                onClick={() => handleFilterClick(fbm.status)}
                key={index}
              >
                <div
                  className={`${
                    filterOptions.previousKey === fbm.status
                      ? " border-b-4 sm:pb-2 pb-1 border-white"
                      : "my-1"
                  } flex gap-2 transition-all ease-in`}
                >
                  <img
                    src={fbm.icon}
                    alt={fbm.status}
                    className="md:h-auto h-2"
                  />
                  <label className="sm:flex hidden">
                    {t(`home.alarmList.status.${fbm.status}`)}
                  </label>
                  &nbsp;(
                  {alarms
                    ? alarms.filter((a) => a.status === fbm.status)?.length
                    : "0"}
                  )
                </div>
              </button>
            ))}
          </div>
        </div>
        <div className="flex flex-col gap-2 h-full">
          {loading && <KendoLoadingPanel />}
          {assets ? (
            groupedAlarms &&
            groupedAlarms.length > 0 &&
            assets?.map((v, index) => {
              const alarms = groupedAlarms?.find((ga) => ga.value === v.id);
              const findSensorParameter = (sensor) => {
                const param = v.parameters.find((p) => p.sensorId === sensor);
                return param;
              };
              return alarms ? (
                <div
                  className="bg-[#9D9DA1] dark:bg-dark-card dark:border-neutral-700 border-neutral-400 border-2 mr-1 pt-2 pb-1 h-auto flex-col relative rounded-lg"
                  key={v.id}
                >
                  <div
                    className={`flex justify-between items-center rounded-t-lg md:px-5 sm:px-4 px-3 ${
                      !alarms?.collapsed ? "sm:mb-3 mb-2" : "pb-2"
                    }`}
                  >
                    <div className="text-white font-semibold md:text-base sm:text-sm text-xs">
                      {v?.name}
                      <label className="text-neutral-500 sm:ml-3 ml-1 md:text-lg sm:text-base text-sm font-medium">
                        |
                        <label
                          className={`dark:bg-zinc-900 bg-zinc-400 text-white md:text-xs sm:text-xxs text-xxxs md:w-24 sm:w-20 w-16 sm:h-6 h-4 md:px-5 sm:px-3 px-2 py-1 rounded-lg sm:ml-3 pl-2`}
                        >
                          {alarms.items.reduce(
                            (total, p) =>
                              total +
                              p.items.reduce(
                                (subtotal, i) => subtotal + i.items.length,
                                0
                              ),
                            0
                          )}
                          &nbsp; {t("home.alarmList.headerText")}
                        </label>
                      </label>
                    </div>
                    <button
                      type="button"
                      className="text-white font-medium text-xs w-5 h-5"
                      onClick={() => onCollapseClick(alarms.value, v.id)}
                    >
                      {alarms && !alarms?.collapsed ? (
                        <img
                          src="drop-arrow-icon.svg"
                          alt="dropArrow"
                          className="rotate-180 sm:h-auto h-2"
                        />
                      ) : (
                        <img
                          alt="dropArrowUp"
                          src="drop-arrow-icon.svg"
                          className="sm:h-auto h-2"
                        />
                      )}
                    </button>
                  </div>
                  {alarms &&
                    !alarms.collapsed &&
                    alarms.items &&
                    alarms.items.map((a) =>
                      a.items.map((ai, index) => {
                        const parameter = findSensorParameter(
                          ai.items[0]?.sensorId
                        );
                        const latestAlarm = ai.items[0];
                        const restAlarms = ai.items.filter(
                          (i) => i.id !== latestAlarm.id
                        );
                        return latestAlarm ? (
                          <div key={index}>
                            <AlarmCard
                              index={0}
                              a={ai}
                              parameter={parameter}
                              alarm={latestAlarm}
                              disabledButtonAlarms={disabledButtonAlarms}
                              acknowledgeAlarm={acknowledgeAlarm}
                              alarmCount={restAlarms.length}
                              onStatusCollapseClick={onStatusCollapseClick}
                              key={index}
                              getTimeZoneDateTime={getTimeZoneDateTime}
                              restAlarmsUpdateCount={
                                restAlarms.filter((x) =>
                                  disabledButtonAlarms.some(
                                    (p) => p.alarmId === x.id
                                  )
                                )?.length || 0
                              }
                              t={t}
                              darkMode={darkMode}
                            />
                            {ai.collapsed &&
                              restAlarms.map((ra, index) => {
                                return (
                                  <AlarmCard
                                    index={index + 1}
                                    a={ai}
                                    parameter={parameter}
                                    alarm={ra}
                                    disabledButtonAlarms={disabledButtonAlarms}
                                    acknowledgeAlarm={acknowledgeAlarm}
                                    alarmCount={null}
                                    onStatusCollapseClick={
                                      onStatusCollapseClick
                                    }
                                    key={index}
                                    getTimeZoneDateTime={getTimeZoneDateTime}
                                    t={t}
                                    darkMode={darkMode}
                                  />
                                );
                              })}
                          </div>
                        ) : null;
                      })
                    )}
                </div>
              ) : null;
            })
          ) : apiLoaded && !config?.homeConfiguration ? (
            <div className="dark:text-slate-500 text-slate-800 flex gap-2 md:text-xs sm:text-xxs text-xxxs font-medium justify-center text-center items-center h-full">
              <Trans i18nKey="home.noConfigureText">
                {t("home.noConfigureText")}
              </Trans>
              <img src="EditIcongray.svg" alt="EditIcon" className="h-6" />
            </div>
          ) : (
            <div className="flex justify-center items-center h-full">
              <Loader />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AlarmList;
